import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { ArrowRight, ArrowLeft } from "@phosphor-icons/react";

import bg from "assests/About/awards/2.jpg";

const AwardsSlider = ({ data }) => {
  const slideRefs = useRef([]);
  const [maxHeight, setMaxHeight] = useState(0);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useLayoutEffect(() => {
    // Ensure slideRefs.current is populated
    if (
      slideRefs.current.length === 0 ||
      slideRefs.current.every((ref) => ref === null)
    ) {
      return;
    }

    // Calculate the maximum height after the DOM is fully rendered
    const heights = slideRefs.current.map((slide) => {
      if (slide) {
        return slide.offsetHeight;
      }
      return 0;
    });

    const maxHeight = Math.max(...heights);

    setMaxHeight(maxHeight);
  }, []);

  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="scroll-section overflow-hidden relative py-36 lg:h-[100vh]  flex flex-col lg:flex-row  lg:items-center gap-x-12"
    >
      <div className="absolute top-0 left-0 w-[100vw] lg:w-1/2 h-full">
        <img className={`w-[100vw] h-full `} src={bg} alt="" />
        <div
          className={`absolute transition ease-in duration-700 w-full h-full inset-0 bg-black opacity-80  mix-blend-multiply ${
            visible ? "translate-x-[100%]" : "translate-x-[0%]"
          }`}
        ></div>
      </div>
      <div
        className={`flex relative z-[10] lg:w-1/4 lg:justify-center lg:items-end flex-col transition ease-in duration-500 ${
          visible
            ? "opactity-100 translate-x-[0%] scale-1"
            : "opacity-0 translate-x-[-10%] scale-[0.6]"
        }`}
      >
        <div className="text-white px-6 xxl:px-0">
          <h2 className="text-6xl lg:text-7xl bebas mb-2">{data?.title}</h2>
          <p className="text-2xl lg:text-3xl">{data?.sub_title}</p>
        </div>
        <div className="flex flex-row lg:flex-col items-end justify-end gap-x-1 mt-6 px-6 lg:px-0">
          <button
            ref={prevRef}
            className="slider-arrow z-[100] solution-prev-button flex items-center justify-center bg-black text-2xl text-font p-4 border border-font"
          >
            <ArrowLeft />
          </button>
          <button
            ref={nextRef}
            className="slider-arrow z-[100] solution-next-button flex items-center justify-center bg-black text-2xl text-font p-4 border border-font"
          >
            <ArrowRight />
          </button>
        </div>
      </div>

      <div className="mt-6 lg:mt-14 lg:w-3/4 lg:ml-auto pl-6 lg:pl-0">
        <Swiper
          spaceBetween={24}
          slidesPerView={1.2}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            992: {
              slidesPerView: 2.5,
              slidesPerGroup: 2,
            },
          }}
          modules={[Autoplay, Navigation]}
          className="-slider "
          speed={1000}
        >
          {data?.data?.map((image, index) => (
            <SwiperSlide
              ref={(el) => {
                slideRefs.current[index] = el;
              }}
              style={{
                height: maxHeight ? `${maxHeight}px` : "auto",
              }}
              className=""
              key={index}
            >
              <div className="border-2 border-white">
                <img
                  className="h-[300px] lg:h-[450px] w-full opacity-[0.8] hover:opacity-[1]"
                  src={image}
                  alt=""
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default AwardsSlider;
